import Kefir from 'kefir';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var $$loop = Symbol('@brookjs/loop');
var NONE = Symbol('@brookjs/none');

var isResult = function isResult(results) {
  return results[$$loop] === true;
};

var loop = function loop(state, action) {
  return Object.assign([state, action], _defineProperty({}, $$loop, true));
};
loop.NONE = NONE;

var normalizeResults = function normalizeResults(results) {
  return isResult(results) ? results : loop(results, NONE);
};

var eddy = function eddy() {
  return function (createStore) {
    return function (reducer, state, enhancer) {
      var queue = [];

      var upgradeReducer = function upgradeReducer(reducer) {
        return function (state, action) {
          var _ref = normalizeResults(reducer(state, action)),
              _ref2 = _slicedToArray(_ref, 2),
              nextState = _ref2[0],
              cmd = _ref2[1];

          if (cmd !== NONE) {
            queue.push(cmd);
          }

          return nextState;
        };
      };

      if (typeof state === 'function') {
        enhancer = state;
        state = undefined;
      }

      var store = createStore(upgradeReducer(reducer), state, enhancer);

      var runCommands = function runCommands(run) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = run[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var cmd = _step.value;

            if (cmd !== NONE) {
              if (Array.isArray(cmd)) {
                runCommands(cmd);
              } else {
                // mutually recursive
                // eslint-disable-next-line no-use-before-define
                dispatch(cmd);
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };

      var dispatch = function dispatch(action) {
        store.dispatch(action);
        var run = queue;
        queue = [];
        runCommands(run);
        return action;
      };

      var replaceReducer = function replaceReducer(reducer) {
        return store.replaceReducer(upgradeReducer(reducer));
      };

      return _objectSpread({}, store, {
        dispatch: dispatch,
        replaceReducer: replaceReducer
      });
    };
  };
};
var combineReducers = function combineReducers(reducerMap) {
  var reducerKeys = Object.keys(reducerMap);
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var hasChanged = false;
    var nextState = {};
    var cmds = [];

    for (var i = 0; i < reducerKeys.length; i++) {
      var key = reducerKeys[i];
      var reducer = reducerMap[key];
      var previousStateForKey = state[key];

      var _normalizeResults = normalizeResults(reducer(previousStateForKey, action)),
          _normalizeResults2 = _slicedToArray(_normalizeResults, 2),
          nextStateForKey = _normalizeResults2[0],
          cmd = _normalizeResults2[1];

      if (cmd !== NONE) {
        cmds.push(cmd);
      }

      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
      nextState[key] = nextStateForKey;
    }

    return loop(hasChanged ? nextState : state, cmds);
  };
};

var fromReduxStore = (function (store) {
  return Kefir.fromESObservable(store).toProperty(store.getState).setName('fromReduxStore');
});

/**
 * Accepts a set of delta generator functions and returns a
 * Middlware function, which generates the `deltas$` stream
 * and binds it to the store.
 *
 * Provides an Observable-based way to respond to events from,
 * and emit events into, the application's central redux store.
 *
 * The delta function takes an `action$` stream and a `state$`
 * stream, and should return a new `delta$` stream, which gets
 * observed by the store. Note that the `action$` stream will
 * re-emit events emitted from the returned `delta$` stream.
 *
 * Exposes the returned subscription, allowing other middleware
 * to terminate the delta.
 *
 * @param {...Function} sources - Source-generating function.
 * @returns {Middleware} Enhanced create store function.
 */
function observeDelta() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  return function (store) {
    var action$ = new Kefir.Stream().setName('action$');
    var state$ = new Kefir.Stream().toProperty(store.getState).setName('state$');
    var emitting = false;
    var queue = [];
    store.subscription = Kefir.merge(sources.map(function (source) {
      return source(action$, state$);
    })).observe({
      error: function error(err) {
        // eslint-disable-next-line no-console
        console.error('Error emitted into delta', err);
      },
      value: function value(_value) {
        if (emitting) {
          queue.push(_value);
        } else {
          store.dispatch(_value);
        }
      }
    });
    return function (next) {
      return function (action) {
        var result = next(action);
        var state = store.getState();
        emitting = true;

        state$._emitValue(state);

        action$._emitValue(result);

        emitting = false;

        if (queue.length) {
          var run = queue;
          queue = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = run[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _action = _step.value;
              store.dispatch(_action);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        return result;
      };
    };
  };
}

export { combineReducers, eddy, fromReduxStore, loop, observeDelta };
